var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('textarea',_vm._b({staticClass:"ui-textarea",class:{ 'ui-textarea_error' : _vm.error },domProps:{"value":_vm.value},on:{"input":_vm.onInput,"change":_vm.onChange}},'textarea',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }